<template>
    <div>
        <a-modal :title="title" :visible='sureVisible' :width="1200" @ok="handleOk" @cancel="handleCancel">
            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <span class="basicTitle">商品证照信息</span>
                
            </div>
            <div>
                <span class="lisenceTitle" >生产企业证照信息</span>
                
            </div>
        </a-modal>
    </div>
</template>
<script>
import { campListMixins } from '../mixins/campListMixins'

export default { 
    name: 'campDetail',
    mixins: [campListMixins],
    data() {
      return { 
        title: '商品证照详情',
        sureVisible:false,
        
      }
    },
    mounted(){
        // this.initShow(e)
    },
    methods: {
        initShow(e){
            console.log(e,'======================e===============')
            this.sureVisible = true

        },
        handleOk(){
            this.sureVisible = false
        },
        handleCancel(){
            this.sureVisible = false
        },
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
